import { setBreadcrumb } from 'shared/common/AppBreadcrumb/model/slice'

import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { useAppDispatch } from 'shared/config/redux/hooks/useRedux'

interface Props {
  key: string
  label?: string
}

export const useDetailPageBreadcrumbs = ({ key, label }: Props) => {
  const params = useParams()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const detailKey = params[key]
    if (detailKey) {
      dispatch(setBreadcrumb({ key: `${key}${detailKey}`, label: label || '' }))
    }
  }, [label])
}
